export default "__VITE_ASSET__a2e872cf__"